
//会员等级，会员设置页面接口
import { get, post, postJson, postBlob } from '../axios2'

const RESOURCE_BASE_PATH = '/PointActivityAnalyticController';

const RESOURCE_BASE_PATH2 = '/PointActivityEffectDetails';

const RESOURCE_BASE_PATH3 = '/joinAndRankActivity';


/***
 * 数据分析-奖品统计-导出表格数据
 * /PointActivityAnalyticController/exportTablePrizeStates
 */
export const getExportTablePrizeStates = p => get(`${RESOURCE_BASE_PATH}/exportTablePrizeStates`, p)

/***
 * 数据分析-活动数据-折线图
 * @param p/
 */
export const getChartEffectDetails = p => get(`${RESOURCE_BASE_PATH}/getChartEffectDetails`, p)

/***
 * 数据分析-奖品统计-折线图
 * 
 */
export const getChartPrizeStates = p => get(`${RESOURCE_BASE_PATH}/getChartPrizeStates`, p)


/***
 * 数据分析-活动数据-折线图
 * @param p/
 */
export const getGoodRecords = p => get(`${RESOURCE_BASE_PATH2}/goodRecords`, p)

/***
 * 积分中心-积分商城-兑换记录idList=[]
 * @param p/
 */
export const getExchangeActivityRecord = p => postJson(`${RESOURCE_BASE_PATH}/getExchangeActivityRecord`, p)


/***
 * 数据分析-活动数据-数据总览
 * @param
 */
export const getSumEffectDetails = p => get(`${RESOURCE_BASE_PATH}/getSumEffectDetails`, p)

/***
 * 数据分析-奖品统计-表格数据
 * @param
 */
export const getTablePrizeStates = p => get(`${RESOURCE_BASE_PATH}/getTablePrizeStates`, p)

/***
 * 数据分析-积分任务-折线图数据
 * @param
 */
export const checkRecord = p => get(`${RESOURCE_BASE_PATH2}/getChartEffectChart`, p)

/***
 * 数据分析-积分任务-汇总数据
 * @param
 */
export const getCouponData = p => get(`${RESOURCE_BASE_PATH2}/getSumEffectDetails`, p)

/***
 * 数据分析-积分任务-列表数据
 * @param
 */
export const getCouponTable = p => get(`${RESOURCE_BASE_PATH2}/getTableEffectDetails`, p)

/***
 * 数据分析-积分任务-签到记录
 * @param
 */
export const checkList = p => get(`${RESOURCE_BASE_PATH2}/singleRecords`, p)

/***
 * 数据分析-积分任务-中奖记录
 * @param
 */
export const awardRecord = p => get(`${RESOURCE_BASE_PATH2}/pointActivityPrizeDetail`, p)

//中奖记录-邀请类
export const awardRecNew = p => get(`${RESOURCE_BASE_PATH2}/pointInviteActivityPrize`, p)

//导出
export const exportRecord = p => get(`${RESOURCE_BASE_PATH2}/exportPointActivityPrizeDetail`, p)

//导出-邀请类
export const exportRecNew = p => get(`${RESOURCE_BASE_PATH2}/exportPointInviteActivityPrize`, p)

/***
 * 数据分析-积分任务-实物名单
 * @param
 */
export const inKindList = p => get(`${RESOURCE_BASE_PATH2}/goodRecords`, p)

/***
 * 数据分析-积分任务-用户资料明细
 * @param
 */
export const improveList = p => get(`${RESOURCE_BASE_PATH2}/memberImproveRecords`, p)

/***
 * 数据分析-积分任务-标记状态
 * @param
 */
export const signIssuance = p => get(`${RESOURCE_BASE_PATH2}/markingSendStatus`, p)

// 下单冲榜-标记发送
export const markingPrizeStatus = id => postJson(`${RESOURCE_BASE_PATH2}/markingPrizeStatus?id=${id}`)
/***
 * 数据分析-积分任务-批量标记状态
 * @param
 */
export const signIssuanceList = p => postJson(`${RESOURCE_BASE_PATH2}/markingSendStatus/batch`, p)

/**
 * 数据分析-获取礼包活动下单转化数据
 * @parm
 */
// export const getShopGiftParticipateConver = p => get(`giftBag/getShopGiftParticipateConver`, p)

export const getShopGiftParticipateConver = p => get(`/PointActivityEffectDetails/getSumEffectOrder`, p)


// 拼券明细
export const getSplitCouponlist = p => postJson(`/splitCoupon/coupon/page`, p)

// 优惠卷统计
export const getStatisticsCouponlist = p => postJson(`splitCoupon/coupon/statistics`, p)

// 团队详情
export const CouponDetail = p => postJson(`/splitCoupon/group/detail`, p)

// 组团明细
export const CouponDetailmember = p => get(`/splitCoupon/group/member/list/${p}`)

// 查询裂变神券
export const CouponDetailID = p => get(`/splitCoupon/${p}`)

// 抽奖机会赠送记录查询列表接口
export const commentDraw = p => get(`/comment/draw/page`, p)

// 抽奖机会赠送记录查询列表接口
export const participation = p => get(`/PointActivityAnalyticController/page/participation`, p)

// 参与赠送记录查询列表接口
export const gameTaskRecord = p => get(`/PointActivityAnalyticController/gameTaskRecord`, p)


// 实物导出验证码
export const getExportCode = p => post(`/public/sendSmsVerifyCode`, p)

// 实物导出验证码
export const getExportxlxs = p => postBlob(`/api/PointActivityEffectDetails/exportGoodRecords`, p)

/***
 * 数据分析-积分任务-打榜记录
 * @param
 */
export const rankList = p => postJson(`${RESOURCE_BASE_PATH3}/rankList`, p)

/***
 * 数据分析-积分任务-打榜记录入会明细列表接口
 * @param
 */
export const getMemberJoinList = p => postJson(`${RESOURCE_BASE_PATH3}/getMemberJoinList`, p)
/***
 * 数据分析-中奖记录列表接口
 * @param
 */
export const pointInviteAttentionPrize = p => get(`/inviteAttentionPointActivity/pointInviteAttentionPrize`, p)
/***
 * 数据分析-中奖记录明细列表接口
 * @param
 */
export const pointInviteAttentionPrizeDetail = p => get(`/inviteAttentionPointActivity/pointInviteAttentionPrizeDetail`, p)

//预约记录/
export const appointment = p => postJson(`/freeTrial/appointment`, p)

/***
 * 数据分析-填写记录
 * @param
 */
export const getWriteData = p => get(`PointActivityEffectDetails/birthDay/page`, p)

/***
 * 数据分析-奖品领取记录
 * @param
 */
export const getPrizeReceiveData = p => get(`/PointActivityEffectDetails/pointActivityPrizeDetail`, p)

/***
 * 数据分析-奖品领取记录
 * @param
 */
export const getWheelPrizeDetail = p => get(`/PointActivityEffectDetails/bigWheelPrizeDetail`, p)

/***
 * 数据分析-查看问卷
 * @param
 */
export const getQueLook = (id,pin) => get(`/question/${id}/${pin}`)

// 数据分析-问卷统计
export const getQueData = p => get(`/question/statistics/${p}`)

// 数据分析-满额有礼-参与记录
export const getActivityRecordList = p => get(`/PointActivityEffectDetails/getActivityRecordList`,p)

// 数据分析-发货接口(单个)
export const markingSendStatusLockRight = p => postJson(`/PointActivityEffectDetails/markingSendStatus`,p)

// 数据分析-下单冲榜-参与记录
export const getJoinRecord = p => get(`/order-rank/getJoinRecord`,p)

// 数据分析-下单冲榜-活动统计
export const getDataOverview = p => get(`/order-rank/activityStatistic/dataOverview`, p)

// 数据分析-下单冲榜-活动统计
export const getActivityStatisticDetail = p => get(`/order-rank/activityStatistic/detail/page`, p)


// 会员升级礼包-参与记录
export const getMemberUpgradeRecord = p => postJson(`/memberUpgradeGift/getMemberUpgradeGiftRecord`, p)

// 会员升级礼包-领取记录
export const getMemberUpgradeReceiveRecord = p => get(`/PointActivityEffectDetails/pointActivityPrizeDetail`, p)
// 会员升级礼包-实物名单
export const getMemberUpgradeInKindList = p => get(`/PointActivityEffectDetails/goodRecords`, p)
//提供给淘互动的加解密接口
export const security = p => postJson(`/openController/taohd/security`, p)
// 数据分析-实物奖品修改收货地址
export const modifyAddressInfo = p => postJson(`/PointActivityEffectDetails/modifyAddressInfo`, p)
